import { useQuery, UseQueryResult } from "react-query";
import { getCrossMerchantTransferPath } from "../../../api/merchant";
import { useReduxContext } from "./reduxContext";
import { GetTableListRes } from "./config";

const useLiquidityProviderTabQuery = (): UseQueryResult<GetTableListRes> => {
  const [state] = useReduxContext();
  const { params, liquidityProviderRefetchCounter } = state;
  return useQuery({
    queryKey: [
      "getCrossMerchantTransferPathLiquidityTab",
      params,
      liquidityProviderRefetchCounter,
    ],
    queryFn: () => getCrossMerchantTransferPath(params),
  });
};
export default useLiquidityProviderTabQuery;
